var boostPFS = new BoostPFS();
boostPFS.init(); 
if (typeof boostPFSConfig != 'undefined'
	&& typeof boostPFSConfig.general != 'undefined' 
	&& typeof boostPFSConfig.general.isInitFilter != 'undefined'
	&& typeof boostPFSThemeConfig != 'undefined'
	&& boostPFSConfig.general.isInitFilter === true) {
	boostPFS.initFilter(); 
} 
BoostPFS.jQ(window).on('load', function(){
	// Empire Pro: initSearchBox re-SUPPRESSED 2026-08-28 for the search typeahead
	// rework. The header + mobile typeahead is now our own <ep-search-typeahead>
	// (assets/ep-search-typeahead.js) against Boost's suggest endpoint; Boost
	// must not also bind input[name="q"] (its binding had the first-interaction
	// failure, and its Enter handling swallowed keydowns). Same suppression as
	// the original 2026-04-27 one, new owner. initAnalytics stays: it powers
	// filter/search-page product-click tracking and the localStorage event-queue
	// flush (suggest clicks + PDP ATC beacons are sent by ep-search-typeahead.js).
	boostPFS.initAnalytics();
});